import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { DotsThreeOutlineVertical } from '@liveauctioneers/hammer-ui-core/icons';
import styled from 'styled-components';

export const StyledMenuContainer = styled.div`
    position: absolute;
    top: 4px;
    right: 3px;
    z-index: 2;
    padding: 0;

    @media print {
        display: none;
    }
`;

export const StyledContainer = styled.div`
    @media print {
        display: flex;
        flex-direction: row;
    }
`;

export const TitleMenuWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const TriggerWrapper = styled.span`
    display: flex;
    justify-content: center;
    cursor: pointer;
`;

export const StyledMenuIcon = styled(DotsThreeOutlineVertical)`
    display: none;

    /* stylelint-disable-next-line */
    ${StyledContainer}:hover & {
        display: inline-block;
    }

    &:hover {
        color: ${({ theme }) => theme.colors.blue200};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        display: inline-block;
    }
`;

export const StyledLink = styled(Link)`
    width: 100%;

    && {
        text-decoration: none;
    }
`;

export const PopoverWrapper = styled.div`
    padding-left: 3px;
`;

export const PopoverContentContainer = styled.div`
    padding: 5px 0;
`;

export const PopoverMenuItem = styled.div`
    font-size: 14px;
    line-height: 20px;
    text-align: flex-start;
    letter-spacing: 0.5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 5px 10px;

    &:hover {
        background-color: ${({ theme }) => theme.colors.grey500};
    }
`;
